import React from "react";
import { connect } from "react-redux";
import { AppState } from "src/redux/store";
import ProjectPage from "src/components/Project";
import { getProject } from "src/redux/projects/selectors";
import * as Stories from "src/redux/stories";
import { WithNamespaces, withNamespaces } from "react-i18next";
import { toast } from "react-toastify";

interface Props {
  projectId: number;
}
function mapDispatchToProps(dispatch) {
  return {
    loadPrestations: (projectId: number) =>
      dispatch(Stories.fetchPrestationListOnce(projectId))
  };
}

const mapStateToProps = (state: AppState, props) => {
  return { project: getProject(state.projects, props) };
};
type PropsWithMapState = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  Props &
  WithNamespaces;

class ProjectContainerToConnect extends React.Component<PropsWithMapState> {
  async componentWillMount() {
    try {
      await this.props.loadPrestations(this.props.projectId);
    } catch (error) {
      toast.error(this.props.t("error.unknown"));
    }
  }

  onIndexChange = (value: number) => {
    if (value === -1) {
      history.back();
    }
  };
  render() {
    if (!this.props.project) {
      return null;
    }

    return <ProjectPage project={this.props.project} />;
  }
}

export const ProjectContainer = withNamespaces()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProjectContainerToConnect)
);



// WEBPACK FOOTER //
// ./src/containers/ProjectContainer.tsx